// require jQuery and attach it to the window
const jq = require('jquery');
(window as any).jQuery = jq;
(window as any).$ = jq;

// require moment and attach it to the window
window.moment = require('moment');

require('angular');
require('angular-sanitize');
require('angular-resource');
require('angular-route');
require('angular-cookies');
require('angular-ui-bootstrap');
require('angular-chart.js');
require('angular-ui-tree');
require('angular-timeago');
require('ng-file-upload');
require('angular-money-directive');
require('angularjs-slider');
require('angular-drag-and-drop-lists');
require('ui-cropper');
require('ui-select');
require('iso-3166-country-codes-angular');
require('moment-timezone');
// require('jquery-minicolors');
require('chart.js');
require('lodash');
